export const serviceNameMapping={
ADB: 'BULK_COLLECTION_FOR_ADB',
GQC: 'BULK_COLLECTION_FOR_GQ',
JODO: 'BULK_COLLECTION_FOR_JODO',
BFL: 'BULK_COLLECTION_FOR_BFL',
PRP: 'BULK_COLLECTION_FOR_PRP',
QRC: 'BULK_COLLECTION_FOR_QRC',
JEMI: 'BULK_COLLECTION_FOR_JEMI',
EXAM: 'BULK_COLLECTION_FOR_EXAM',
OTHER: 'BULK_COLLECTION_FOR_OTHERS'
}

export const bulkPayModeUploadDropdown=[
    {label:'ADB', value:'ADB'},
    {label:'Gray Quest', value:'GQC'},
    {label:'JODO', value:'JODO'},
    {label:'PRP', value:'PRP'},
    {label:'BFL', value:'BFL'},
    {label:'QRC', value:'QRC'},
    {label:'JEMI', value:'JEMI'},
    {label:'EXAM', value:'EXAM'},
    {label:'OTHER', value:'OTHER'}
]


export const initialForm={
    paymentMode:[],
    status:[],
    fromProcessingDate:'',
    toProcessingDate:''
}
export const paymodeNameMpping={
    BFL:'BFL - Bajaj finserv ltd',
    PRP: 'PRP - Propelled',
    QRC: 'QRC - QR Code',
    GQC: 'GQC - Grayquest',
    JODO: 'JODO - eNACH Payment',
    ADB: 'ADB - Amount Deposited in Bank',
    JEMI: 'JEMI - JODO EMI',
    EXAM: 'Exam - Exam Bulk ',
    OTHER: 'OTHER – Other Payments',
    SUP:'OTHER – Other Payments'

}

export const statusStyle = {
    FAILED: {
      backgroundColor: "#F9D9D7",
      color: "#B32306",
      padding: "4px 11px",
      fontSize: "12px",
      borderRadius: "8px",
    },
    SUCCESS: {
      backgroundColor: "#BBE2CE",
      color: "#0B442D",
      padding: "4px 11px",
      fontSize: "12px",
      borderRadius: "8px",
    },
      PROCESSING: {
      backgroundColor: "#FFEDC8",
      color: "#705010",
      padding: "4px 11px",
      fontSize: "12px",
      borderRadius: "8px",
    },
    COMPLETED:{
      backgroundColor: "#BBE2CE",
      color: "#0B442D",
      padding: "4px 11px",
      fontSize: "12px",
      borderRadius: "8px",
    },
  };
  
  export const statusMapping = {
    SUCCESS: "Success",
    FAILED: 'Failed',
    PROCESSING: 'In-Progress',
    COMPLETED: 'Completed'
  };

  export const checkUploadedPidExist=(pid,rows)=>{
    if(rows?.[0]?.processInstanceId==pid)
      return true
    else
    return false
  }
  export const getPaymentModeAndProcessIdMapping = (payModeProcessNameObj, procssList = []) => {
    return procssList.find((item) => {
        if (item?.tagTypeKey == payModeProcessNameObj?.tagTypeKey) {
            return item;
        }

    })
}
export const payModeProcessTagTypeMapping = [
    { payMode: 'BFL', tagTypeKey: 'BULK_COLLECTION_FOR_BFL' },
    { payMode: 'QRC', tagTypeKey: 'BULK_COLLECTION_FOR_QRC' },
    { payMode: 'ADB', tagTypeKey: 'BULK_COLLECTION_FOR_ADB' },
    { payMode: 'JODO', tagTypeKey: 'BULK_COLLECTION_FOR_JODO' },
    { payMode: 'GQC', tagTypeKey: 'BULK_COLLECTION_FOR_GQ' },
    { payMode: 'PRP', tagTypeKey: 'BULK_COLLECTION_FOR_PRP' },
    {payMode: 'JEMI', tagTypeKey: 'BULK_COLLECTION_FOR_JEMI' },
    {payMode: 'EXAM', tagTypeKey: 'BULK_COLLECTION_FOR_EXAM' },
    {payMode: 'OTHER', tagTypeKey: 'BULK_COLLECTION_FOR_OTHERS' }

]